import { Component, OnInit, Renderer2, ViewChild, AfterViewInit, ChangeDetectorRef, NgZone } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { NgxSpinnerService } from "ngx-spinner";
import { forkJoin, of, Subscription } from "rxjs";
import { catchError, finalize } from 'rxjs/operators';
import { DatatableConfig } from "src/app/config/DatatableConfig";
import {
  IAsignatura,
  IDocente,
  IEvaluacionesFechas,
  IResDescargaArchivo,
  IResRegistroCalificaciones,
  ITabla,
  ITablaBody,
  ITablaBodyRow,
  ITablaCalificaciones,
  ITablaHeaders,
} from "src/app/interfaces/calificaciones";
import {
  ICalificacionesAlineacion,
  IResSincronizarBlackboard,
} from "src/app/interfaces/integracion-blackboard";
import { IActa } from "src/app/interfaces/portal-calificaciones";
import { IntegracionesBlackboardService } from "src/app/services/integraciones-blackboard/integraciones-blackboard.service";
import { PerfilamientoService } from "src/app/services/perfilamiento/perfilamiento.service";
import { PortalCalificacionesService } from "src/app/services/portal-calificaciones/portal-calificaciones";
import { RegistroCalificacionesService } from "src/app/services/registro-calificaciones/registro-calificaciones.service";
import { UtilsFnService } from "src/app/services/utils/utils-fn.service";
import { WebSocketService } from "src/app/services/web-socket/web-socket.service";

import { environment } from "src/environments/environment";
import { EvaluacionesFechasService, IEvaluacionFechaDTO } from "src/app/services/registro-fecha-eval/evaluaciones-fechas.service";
declare let $: any;
import { MatCalendar } from '@angular/material/datepicker';

@Component({
  selector: "app-visualizacion-seccion",
  templateUrl: "./visualizacion-seccion.component.html",
  styleUrls: ["./visualizacion-seccion.component.scss"],
})
export class VisualizacionSeccionComponent implements OnInit, AfterViewInit {
  dtOptions: DataTables.Settings = {};
  asignatura: IAsignatura | null = null;
  docentes: IDocente[] = [];
  tablaCalificacionesRes: ITablaCalificaciones | null = null;
  tablaCalificaciones: ITablaCalificaciones | null = null;
  renderTablaCalificaciones: boolean = false;
  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective | undefined;
  infoModalTitulo: string = "";
  infoModalTexto: string = "";
  alertaExito: string = "";
  collapsedItems: any = [];
  configuracion: any;
  nombreRutAlumnoFiltro: string = "";

  registrosGuardados: boolean = false;
  configuracionFiltros: any = {};

  registrosEditables: boolean = false;
  registrosModificados: boolean = false;

  mostrarInfoCalificacion: boolean = false;
  infoCalificacion: any;
  error: string = "";

  timeoutAutoguardado: any;
  strUltimaActualizacion: string = "";
  loadingAutoguardado: boolean = false;

  tipoNotasReq = ["CP", "CE", "EX", "AN"];
  estadoTabla: string = "";
  tipoPortafolioTabla: boolean = false;
  estadoSeccion: string = "";

  mostrarActa: boolean = false;
  alineacionRealizada: boolean = true;

  private intervalEstadoAlumnos: any;

  eventoNotasSubscription: Subscription | null = null;
  eventoEstadoAlumnosSubscription: Subscription | null = null;

  arrNotasPorEnviar: any = [];
  loadingSocket: boolean = false;

  ponderacionesAlineacionBb: ICalificacionesAlineacion | null = null;
  arrPonderacionesSincronizacionBb: string[] = [];

  mostrarBtnObtenerCalificaciones = true;
  idCursoBlackboard = "";
  alineacionBbRealizada = false;
  btnObtenerCalificacionesDeshabilitado = false;
  datosAlineacion: any = {};
  mensajeError = "";
  deshabilitarSelectAll = false;
  tipoAlineacion = "";

  // ====== FECHAS EVALUACIONES ======
  fechasBase: IEvaluacionesFechas[] = [];
  fechasDraft: IEvaluacionesFechas[] = [];
  datosListaEvaluaciones: IEvaluacionesFechas[] = [];

  selectedIndex: number | null = null;
  selectedDate: Date | null = null;
  prevSelectedDate: Date | null = null;
  hasChanges = false;
  ponderacionBaseId = 0;

  @ViewChild('cal', { static: false }) calendar?: MatCalendar<Date>;


  constructor(
    private readonly _registroCalificaciones: RegistroCalificacionesService,
    private readonly _evaluacionesFechas: EvaluacionesFechasService,
    private readonly router: Router,
    private readonly spinner: NgxSpinnerService,
    private readonly _portalService: PortalCalificacionesService,
    private readonly _utilsFn: UtilsFnService,
    private readonly webSocketService: WebSocketService,
    private readonly _perfilamiento: PerfilamientoService,
    private readonly renderer: Renderer2,
    private readonly _integracionBb: IntegracionesBlackboardService,
    private readonly zone: NgZone,
    private readonly cdr: ChangeDetectorRef
  ) {
    const routerData =
      this.router.getCurrentNavigation()?.extras?.state?.["data"];
    this.tipoAlineacion = routerData?.tipoAlineacion;
    this.alineacionRealizada = routerData?.resultadoServicio
      ? routerData?.resultadoServicio
      : false;
    if (routerData?.filtros) {
      this.configuracionFiltros = routerData.filtros;
    }
    if (routerData?.estado) {
      this.estadoSeccion = routerData.estado;
    }
    if (this.configuracionFiltros.tablaCalificaciones) {
      this.tablaCalificaciones = this.configuracionFiltros.tablaCalificaciones;
    }
    if (routerData?.alineacion) {
      this.datosAlineacion = routerData.alineacion;
    }
    if (routerData?.configuracion) {
      this.configuracion = routerData.configuracion;
      this.registrosEditables = routerData?.editable;
      this.obtenerCalificaciones();
    } else {
      this.router.navigate(["/portal-calificacion"]);
    }

    window.addEventListener("online", () => {
      this.conexionSocket();
      this.obtenerCalificaciones();
      this.obtenerFechasEvaluaciones()
    });
    window.addEventListener("offline", () => {
      this.spinner.show();
    });
  }

  ngOnInit(): void {
    this.dtOptions = { ...DatatableConfig.dtOptionsFixedLeftColumnCalificaciones };

    if (this.estadoSeccion !== "CERRADA") {
      this.conexionSocket();

      this.webSocketService.connectionStatus$.subscribe((status: string) => {
        if (
          status === "closed" ||
          status === "error" ||
          status === "disconnected"
        ) {
          this.loadingSocket = true;
          this.spinner.show();
        } else {
          if (this.loadingSocket) {
            this.loadingSocket = false;
            this.spinner.hide();
            this.reenviarNotasPendientes();
          }
        }
      });

      this.intervalEstadoAlumnos = setInterval(() => {
        this.sendSocketInfoEstadoAlumnos();
      }, environment.tiempoSocketEstadoAlumnos * 1000);
    }
  }
  // ====== funciones para fechas evaluaciones ======

  /** Enlazamos open/close del modal para manejar el draft */
  ngAfterViewInit(): void {
    const evaluaciones = document.getElementById('fechaEvaluaciones');
    if (evaluaciones && $) {
      $(evaluaciones).on('show.bs.modal', () => this.zone.run(() => this.onOpenFechasModal()));
      $(evaluaciones).on('hidden.bs.modal', () => this.zone.run(() => this.onCloseFechasModal()));
    }
  }

  fechasMap = new Map<string, string>();

  private buildFechasMap(): void {
    this.fechasMap.clear();
    (this.fechasBase || []).forEach(e => {
      if (!e?.sigla) return;
      if (e.fecha) this.fechasMap.set(`${e.tipoEva}${e.nroNota} (${e.porcentaje}%)`, e.fecha);
    });
  }

  private siglaFromHeader(header: any): string | null {
    if (header?.valor) return String(header.valor).toUpperCase();
    const v = String(header?.valor ?? '');
    const m = v.match(/^([A-Za-z]+[0-9]*)/);
    return m ? m[1].toUpperCase() : null;
  }

  hasFecha(header: any): boolean {
    let s = this.siglaFromHeader(header);
    if (s) s = s.replace('CEE','EX')
    return !!(s && this.fechasMap.get(s));
  }

  getTooltipFechaHeader(header: any): string {
    let s = this.siglaFromHeader(header);
    if (s) s = s.replace('CEE','EX')
    const f = s ? this.fechasMap.get(s) : null;
    return f ? `Fecha evaluación: ${f}` : '';
  }

  private mapEval(api: IEvaluacionFechaDTO): IEvaluacionesFechas {
    return {
      sigla: api.tipoCalificacion + api.nroNota,
      tipoEva: api.tipoCalificacion,
      nombre: api.nombre,
      descripcion: api.glosa || '-',
      porcentaje: api.porcentaje,
      fecha: api.fechaEvaluacion ?? undefined,
      nroNota: api.nroNota,
      seccionEvaluacionId: api.seccionEvaluacionId,
      isSelected: false,
      isEditable: api.editable,
      ponderacionBaseId: api.ponderacionBaseId
    };
  }
  
  private toISO(d: Date): string {
    const y = d.getFullYear();
    const m = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = d.getDate().toString().padStart(2, '0');
    return `${day}/${m}/${y}`;
  }
  
  private parseISO(iso: string): Date {
    const [d, m, y] = iso.split('/').map(Number);
    return new Date(y, (m ?? 1) - 1, d ?? 1);
  }

  private resetCalendarToToday(): void {
    const today = new Date();
    this.prevSelectedDate = null;
    this.selectedDate = today;
    if (this.calendar) {
      this.calendar.activeDate = today;
      this.calendar.updateTodaysDate();
    }
  }

  private onOpenFechasModal(): void {
    this.fechasDraft = JSON.parse(JSON.stringify(this.fechasBase || []));
    this.selectedIndex = null;
    this.selectedDate = null;
    this.prevSelectedDate = null;
  
    this.datosListaEvaluaciones = [...this.fechasDraft];
  
    this.hasChanges = false;
    this.cdr.detectChanges();
  }

  private onCloseFechasModal(): void {
    this.fechasDraft = [];
    this.selectedIndex = null;
    this.selectedDate = null;
    this.prevSelectedDate = null;

    this.hasChanges = false;
    this.cdr.detectChanges();
  }

  guardarModalFechas(): void {
    const jsonDatos = (this.fechasDraft || [])
      .map(e => ({ tipoNota: e.tipoEva, nroNota: e.nroNota ,fechaEvaluacion: e.fecha || null }));
  
    const body = {
      seccionEvaluacionId: this.fechasDraft?.[0]?.seccionEvaluacionId || 0,
      ponderacionBaseId: this.ponderacionBaseId,
      idSeccion: this.configuracion.seccionId,
      jsonDatos
    };
  
    this._evaluacionesFechas.postGuardarEvaluacionesFechas(body).subscribe({
      next: () => {
        this.fechasBase = JSON.parse(JSON.stringify(this.fechasDraft || []));
        this.datosListaEvaluaciones = this.fechasBase;
        this.buildFechasMap();
        this.hasChanges = false;
        this.cerrarModalFechas();
        this.obtenerFechasEvaluaciones()
      },
      error: (err) => {
        console.error('Error guardando fechas evaluaciones', err);
        this.cerrarModalFechas();
      }
    });
  }

  cerrarModalFechas(): void {
    setTimeout(() => {
      document.getElementById("modal-fechaEvaluaciones-close")?.click();
      this.resetCalendarToToday()
    }, 150);
  }

  onSelectEvaluacion(i: number): void {
    if (!this.fechasDraft) return;
  
    if (this.selectedIndex === i) {
      this.selectedIndex = null;
      this.selectedDate = null;
      this.prevSelectedDate = null;
      this.fechasDraft.forEach(e => e.isSelected = false);
      this.datosListaEvaluaciones = [...this.fechasDraft];
      this.cdr.detectChanges();
      return;
    }
  
    this.fechasDraft.forEach(e => e.isSelected = false);
    this.fechasDraft[i].isSelected = true;
    this.selectedIndex = i;
  
    const f = this.fechasDraft[i].fecha;
    if (f) {
      const d = this.parseISO(f);
      this.prevSelectedDate = null;
      this.selectedDate = d;
      if (this.calendar) {
        this.calendar.activeDate = d;
        this.calendar.updateTodaysDate();
      }
    } else {
      this.prevSelectedDate = null;
      this.selectedDate = null;
    }
  
    this.datosListaEvaluaciones = [...this.fechasDraft]; // <—
    this.cdr.detectChanges();
  }
  
  onCalendarChange(date: Date): void {
    this.prevSelectedDate = this.selectedDate;
    this.selectedDate = date;
    if (this.selectedIndex !== null) this.hasChanges = true;
    this.cdr.markForCheck();
  }
  
  confirmarFecha(): void {
    if (this.selectedIndex === null || !this.selectedDate || !this.fechasDraft) return;
    const iso = this.toISO(this.selectedDate);
    const ev = this.fechasDraft[this.selectedIndex];
    const cambio = ev.fecha !== iso;
  
    ev.fecha = iso;
    if (cambio) this.hasChanges = true;
  
    this.datosListaEvaluaciones = [...this.fechasDraft];
    this.cdr.detectChanges();
  }

  obtenerFechasEvaluaciones(): void {
    const $obtenerEvaluaciones = this._evaluacionesFechas
      .getEvaluacionesFechas({ ...this.configuracion, ponderacionId: this.ponderacionBaseId})
      .pipe(
        catchError(err => {
          console.error('Error al consultar fecha evaluaciones', err);
          return of([] as IEvaluacionFechaDTO[]);
        })
      );

    forkJoin({
      evaluaciones: $obtenerEvaluaciones
    })
    .subscribe(({evaluaciones }) => {
      this.fechasBase = (evaluaciones || []).map(e => this.mapEval(e));
      this.datosListaEvaluaciones = this.fechasBase;

      // Construye mapa para tooltips desde la fuente
      this.buildFechasMap();
    });
  }

  // ====== fin funciones fechas evaluaciones ======

  conexionSocket() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId,
    };
    this.webSocketService.initializeWebSocketConnection(websocketParams);
    this.eventoNotasSubscription = this.webSocketService.eventoNota$.subscribe(
      (event: any) => {
        this.modificarNotaDesdeSocket(event);
      }
    );

    this.eventoEstadoAlumnosSubscription =
      this.webSocketService.eventoEstadoAlumnosObs$.subscribe((event: any) => {
        this.modificarEstadoAlumnoDesdeSocket(event);
      });
  }

  modificarNotaDesdeSocket(event: any) {
    if (event.indexRow && event.indexBody) {
      this.tablaCalificaciones!.body[event.indexBody].row[
        event.indexRow
      ].valor = event.valor;
      this.tablaCalificaciones!.body[event.indexBody].row[
        event.indexRow
      ].nuevoValor = event.valor;
    } else {
      const alumnoFiltrado = this.tablaCalificaciones?.body.find(
        (alumno: ITablaBody) =>
          alumno.alumnoId === event.alumnoId && alumno.idCs === event.idCs
      );
      if (alumnoFiltrado) {
        alumnoFiltrado.row.forEach((alumnoRow: ITablaBodyRow) => {
          if (
            alumnoRow.tipoNota === event.tipoNota &&
            alumnoRow.nroNota === event.nroNota
          ) {
            alumnoRow.valor = event.valor;
            alumnoRow.nuevoValor = event.valor; // se elimina event.nuevoValor ya que nunca trae ese valor del websocket
          }
        });
        setTimeout(() => {
          this.calcularCpCe();
        }, 80);
      }
    }
    this.validarListaNotas(event);
  }

  validarListaNotas(notaDesdeSocket: any) {
    const indexNota = this.arrNotasPorEnviar.findIndex(
      (nota: any) =>
        nota.alumnoId === notaDesdeSocket.alumnoId &&
        nota.idCs === notaDesdeSocket.idCs &&
        nota.tipoNota === notaDesdeSocket.tipoNota &&
        nota.nroNota === notaDesdeSocket.nroNota
    );
    if (indexNota !== -1) {
      this.arrNotasPorEnviar.splice(indexNota, 1);
    }
  }

  reenviarNotasPendientes() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId,
    };
    this.arrNotasPorEnviar.forEach((nota: any) => {
      let message = JSON.stringify(nota);
      this.webSocketService.sendMessage(websocketParams, message);
    });
  }

  modificarEstadoAlumnoDesdeSocket(event: any) {
    if (event.alumnos) {
      this.tablaCalificaciones?.body.forEach((alumno: ITablaBody) => {
        const alumnoEventFilter: any = event.alumnos.find(
          (alumnoEvent: any) =>
            alumno.alumnoId === alumnoEvent.alumnoId &&
            alumno.idCs === alumnoEvent.idCs
        );
        if (alumnoEventFilter) {
          alumno.situacionFinal = alumnoEventFilter.situacionFinal;
          alumno.row[alumno.row.length - 2].valor =
            alumnoEventFilter.situacionFinal;

          if (
            alumnoEventFilter.situacionFinal === "RI" ||
            alumnoEventFilter.situacionFinal === "PP"
          ) {
            this.habilitarCpCeExSocket(alumno, false);
            this.calcularCpCe();
          } else {
            this.habilitarCpCeExSocket(alumno);
          }
        }
      });
    }
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutAutoguardado);
    clearInterval(this.intervalEstadoAlumnos);
    this.webSocketService.disconnect();
  }

  changeFiltro() {
    if (this.nombreRutAlumnoFiltro === "") {
      this.nombreRutAlumnoFiltro = "   ";
      setTimeout(() => {
        this.nombreRutAlumnoFiltro = "";
      }, 5);
    }
  }

  validarVolver() {
    if (this.arrNotasPorEnviar.length === 0) {
      this.volverAPortal();
    } else {
      document.getElementById("btn-modal-cambios-pendientes")?.click();
    }
  }

  volverAPortal(): void {
    if (this.arrNotasPorEnviar.length === 0) {
      document.getElementById("modal-cambios-pendientes-close")?.click();
    }
    clearTimeout(this.timeoutAutoguardado);
    this.router.navigate(["/portal-calificacion"], {
      state: {
        data: {
          filtros: this.configuracionFiltros,
        },
      },
    });
  }

  manejoResCalificaciones(res: ITabla, cierreSeccion: boolean = false) {
    if (res.asignatura) {
      this.asignatura = res.asignatura;
    }
    if (res.docentes) {
      this.docentes = res.docentes;
    }
    this.estadoTabla = res.estado;
    this.tipoPortafolioTabla = res.tipoPortafolio;
    if (res.tabla) {
      this.tablaCalificacionesRes = res.tabla;
      this.tablaCalificaciones = res.tabla;
      if (this.tablaCalificaciones.headers.length <= 17) {
        // Por validar
        this.dtOptions = { ...DatatableConfig.dtOptionsCalificacionesNotFixed };
      } else {
        this.dtOptions = { ...DatatableConfig.dtOptionsFixedLeftColumnCalificaciones };
      }
      this.tablaCalificaciones.headers.forEach((columna) => {
        if (
          columna.columanBb?.ultimaActualizacion &&
          !columna.columanBb.encontradaBb
        ) {
          columna.columanBb.encontradaBb = true;
        }
      });
      if (this.registrosGuardados) {
        this.renderTablaCalificaciones = false;
        setTimeout(() => {
          this.renderTablaCalificaciones = true;
        }, 500);
      } else {
        this.renderTablaCalificaciones = true;
      }

      setTimeout(() => {
        this.datatableElement?.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.columns.adjust();
        });
      }, 1000);
    }
    if (this.registrosGuardados) {
      this.mostrarAlertaExito("Se ha grabado con éxito.");
      this.registrosGuardados = false;
    }
  }
  
  obtenerCalificaciones(cierreSeccion: boolean = false) {
    if (!this.registrosGuardados) this.renderTablaCalificaciones = false;

    const $obtenerTabla = this._registroCalificaciones.getCalificaciones(this.configuracion);
    const $obtenerTablaHeaders = this._registroCalificaciones.getCalificacionesTablaHeaders(this.configuracion);
    const $obtenerTablaSeccion = this._registroCalificaciones.getCalificacionesTablaSeccion(this.configuracion);

    forkJoin({
      obtenerTabla: $obtenerTabla,
      obtenerTablaHeaders: $obtenerTablaHeaders,
      obtenerTablaSeccion: $obtenerTablaSeccion
    })
    .pipe(finalize(() => {
      this.obtenerFechasEvaluaciones()
      this.renderTablaCalificaciones = true
    }))
    .subscribe(({ obtenerTabla, obtenerTablaHeaders, obtenerTablaSeccion }) => {
      const newRes: any = { ...obtenerTablaSeccion, ...obtenerTablaHeaders};
      newRes.tabla.body = obtenerTabla
      this.ponderacionBaseId = newRes.tabla.body[0].ponderacionBaseId
      if (newRes?.acta) this.mostrarActa = true;
      if (newRes?.estado === 'C') cierreSeccion = true;
      this.manejoResCalificaciones(newRes, cierreSeccion);

      this.alineacionBbRealizada = obtenerTablaSeccion.cursoAlineadoBlackboard;
      if (obtenerTablaSeccion.cursoSincronizadoBlackboard) {
        this.mostrarBtnObtenerCalificaciones = false;
        this.idCursoBlackboard = obtenerTablaSeccion.cursoBlackboard;
      }
    });
  }

  collapseAlumno(index: number) {
    const indexOf = this.collapsedItems.indexOf(index);
    if (indexOf > -1) {
      this.collapsedItems.splice(indexOf, 1);
    } else {
      this.collapsedItems.push(index);
    }
  }

  alumnoCollapsed(index: number) {
    return this.collapsedItems.indexOf(index) === -1;
  }

  mostrarInfoModal(titulo: string, texto: string) {
    this.infoModalTitulo = titulo;
    this.infoModalTexto = texto;
    document.getElementById("btn-modal-info")?.click();
  }

  mostrarAlertaExito(texto: string) {
    this.alertaExito = texto;
    setTimeout(() => {
      this.alertaExito = "";
    }, 3000);
  }

  modificarCalificacion(
    indexBody: number,
    indexRow: number,
    calificacion: any,
    event: any,
    focusOut: boolean = false
  ) {
    const originalIndex = this.getOriginalIndex(indexBody);
    if ( originalIndex ) {
      indexBody = originalIndex
      calificacion = this.tablaCalificaciones?.body?.[indexBody].row?.[indexRow]
    }

    if (calificacion.valor !== event.target.value) {
      calificacion.nuevoValor = event.target.value;
      calificacion.timestamp = Date.now();
      this.registrosModificados = true;

      if (focusOut) {
        this.sendSocketInfo(indexBody, calificacion, indexRow);
      }
    } else {
      calificacion.nuevoValor = event.target.value;
    }
  }

  modificarAnotaciones(
    indexBody: number,
    indexRow: number,
    calificacion: any,
    event: any
  ) {
    const originalIndex = this.getOriginalIndex(indexBody);
    if ( originalIndex ) {
      indexBody = originalIndex
    }
    this.modificarCalificacion(indexBody, indexRow, calificacion, event);
  }

  // Mobile
  getHeaderIndexByKey(valor: string) {
    const index: any = this.tablaCalificaciones?.headers.findIndex(
      (header: ITablaHeaders) => header.valor === valor
    );
    return index;
  }

  ingresoCalificacionesMobile() {
    this.router.navigate(["/seleccion-calificacion"], {
      state: {
        data: {
          tablaCalificaciones: this.tablaCalificaciones,
          filtros: this.configuracionFiltros,
          asignatura: this.asignatura,
          docentes: this.docentes,
          configuracion: this.configuracion,
          editable: this.registrosEditables,
        },
      },
    });
  }

  allowNumericDigitsOnlyOnKeyUp(
    e: any,
    indexBody: number,
    i: number,
    row: any
  ) {
    this._utilsFn.allowNumericDigitsOnlyOnKeyUp(e, indexBody, i, row); // No se considera indexBody filtrado
    this.modificarCalificacion(indexBody, i, row, e);
  }

  keyUpCalificacion(e: any, indexBody: number, i: number, row: any) {
    setTimeout(() => {
      e.target.value = e.target.value.replace(/[^\d,]/g, "");
      if (e.target.value.length > 3) {
        e.target.value = e.target.value.substring(0, 3);
        this.modificarCalificacion(indexBody, i, row, e);
      }
      if (e.target.value.length === 2 && !e.target.value.includes(",")) {
        e.target.value = e.target.value[0] + "," + e.target.value[1];
        this.modificarCalificacion(indexBody, i, row, e);
      }

      if (
        (e.target.value.length === 3 && +e.target.value[0] > 7) ||
        (e.target.value.length === 3 &&
          e.target.value[0] === "7" &&
          e.target.value[2] !== "0")
      ) {
        e.target.value = "0,0";
        this.modificarCalificacion(indexBody, i, row, e);
      }
    }, 300);
  }

  focusIn(e: any, indexBody: number, i: number, row: any) {
    this.mostrarInfoCalificacion = true;
    const indexNombreAlumno = this.tablaCalificaciones?.headers.findIndex(
      (header) => header.valor === "Nombre"
    );
    const originalIndex = this.getOriginalIndex(indexBody);
    if ( originalIndex ) {
      indexBody = originalIndex
    }
    if (indexNombreAlumno) {
      this.infoCalificacion = {
        nombreAlumno: this.tablaCalificaciones?.body[indexBody].row[indexNombreAlumno].valor,
        tipo: this.tablaCalificaciones?.headers[i].valor,
        descripcion: this.tablaCalificaciones?.headers[i].descripcion,
        alineacion: this.tablaCalificaciones?.headers[i].columanBb,
      };
      $(".toast")?.toast("show");
    }
  }

  sendSocketInfo(indexBody: number, row: any, i: number) {
    const idDocente: number | null =
      this._perfilamiento.getUsuario().tipoUsuario === "Backoffice"
        ? this.configuracionFiltros?.dataDocente?.funcionarioId
        : null;
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId,
    };
    const dataAlumno: any = this.tablaCalificaciones?.body[indexBody];
    let nota = {
      alumnoId: dataAlumno.alumnoId,
      idCs: dataAlumno.idCs,
      valor: row.valor,
      nuevoValor: row.nuevoValor,
      tipoNota: row.tipoNota,
      nroNota: row.nroNota,
      indexBody: indexBody,
      indexRow: i,
      docenteId: idDocente,
    };
    let message = JSON.stringify(nota);
    this.arrNotasPorEnviar = [...this.arrNotasPorEnviar, nota];
    this.webSocketService.sendMessage(websocketParams, message);
  }

  sendSocketInfoEstadoAlumnos() {
    const websocketParams = {
      anyo: this.configuracion.anyo,
      periodoId: this.configuracion.periodoId,
      asignaturaId: this.configuracion.asignaturaId,
      sedeId: this.configuracion.sedeId,
      seccionId: this.configuracion.seccionId,
    };
    let estadoAlumnosArr: any = [];
    this.tablaCalificaciones?.body.forEach((alumno: any) => {
      estadoAlumnosArr = [
        ...estadoAlumnosArr,
        {
          alumnoId: alumno.alumnoId,
          idCs: alumno.idCs,
          situacionFinal: alumno.situacionFinal,
        },
      ];
    });
    let message = JSON.stringify({ alumnos: estadoAlumnosArr });
    this.webSocketService.sendEstadosAlumnos(websocketParams, message);
  }

  pasaFiltro(alumno: any): boolean {
    if (!this.nombreRutAlumnoFiltro) {
      return true; // Sin filtro, todos los alumnos pasan
    }
    return alumno.row.some((item: any) =>
      item.valor.toLowerCase().includes(this.nombreRutAlumnoFiltro.toLowerCase())
    );
  }

  getOriginalIndex(filteredIndex: number): number | undefined {
    const filteredBody: any = this.tablaCalificaciones?.body.filter((alumno: any) =>
      this.pasaFiltro(alumno)
    );
    const alumnoFiltrado = filteredBody[filteredIndex];
    return this.tablaCalificaciones?.body.findIndex(
      (alumno: any) => alumno === alumnoFiltrado
    );
  }

  focusOut(
    e: any,
    indexBody: number,
    i: number,
    row: any,
    tipoAnotacion: boolean = false
  ) {
    if (!tipoAnotacion) {
      this._utilsFn.focusOut(e, indexBody, i, row);
      setTimeout(() => {
        this.calcularCpCe();
      }, 120);
    }
    this.modificarCalificacion(indexBody, i, row, e, true);
    this.mostrarInfoCalificacion = false;
    setTimeout(() => {
      if (!this.mostrarInfoCalificacion) {
        $(".toast")?.toast("hide");
      }
    }, 500);
  }

  fnNotasIncompletasCp(body: any): any {
    return body.row.filter(
      (row: ITablaBodyRow) =>
        row.tipoNota === "CP" &&
        row.editable === true &&
        ((!row.hasOwnProperty("nuevoValor") && row.valor === "0,0") ||
          (row.hasOwnProperty("nuevoValor") && row.nuevoValor === "0,0"))
    );
  }

  fnNotasIncompletasCe(body: any): any {
    return body.row.filter(
      (row: ITablaBodyRow) =>
        row.tipoNota === "CE" &&
        row.editable === true &&
        ((!row.hasOwnProperty("nuevoValor") && row.valor === "0,0") ||
          (row.hasOwnProperty("nuevoValor") && row.nuevoValor === "0,0"))
    );
  }

  fnNotasIncompletasArrRowValor(row: any, notasIncompletasCp: any): any {
    if (notasIncompletasCp.length > 0) {
      row.valor = "0,0";
    }
    return row.valor;
  }

  fnRowValorPromedioCeEx(row: any, promedioCe: any, promedioEx: any): any {
    const promedioCeEx: any = promedioCe > promedioEx ? promedioCe : promedioEx
    row.valor = (Math.round(promedioCeEx * 10) / 10)
      .toFixed(1)
      .toString()
      .replace(".", ",");
    return row.valor;
  }

  calcularPromedioCpDos(alumno: ITablaBody, tipoNota: string): number {
    let promedio = 0;
    const arrNotas: any = alumno.row.filter((filtroAlumno: ITablaBodyRow) => filtroAlumno.tipoNota === tipoNota);
    arrNotas.forEach((calificacion: ITablaBodyRow) => {
      let valorCalificacion = parseFloat(calificacion.nuevoValor?.replace(",", ".") ?? calificacion.valor?.replace(",", "."));
      if (!isNaN(valorCalificacion)) {
        promedio += valorCalificacion * (calificacion.porcentaje / 100);
      }
    });
    return Math.round(parseFloat(promedio.toFixed(2))*10)/10;
  }

  calcularCpCe() {
    this.tablaCalificaciones?.body.forEach((body: ITablaBody) => {
      let porcentajeCp = 0;
      let porcentajeCe = 0;

      const notasIncompletasCp = this.fnNotasIncompletasCp(body);
      const notasIncompletasCe = this.fnNotasIncompletasCe(body);

      const promedioCp = this.calcularPromedioCpDos(body, 'CP')
      const promedioCe = this.calcularPromedioCpDos(body, 'CE')
      const promedioEx = this.calcularPromedioCpDos(body, 'EX')

      body.row.forEach((row: ITablaBodyRow, rowIndex) => {
        if (this.tablaCalificaciones?.headers[rowIndex].valor.includes("PCP")) {
          // En caso de validar porcentaje && isNaN(+this.tablaCalificaciones?.headers[rowIndex].valor[3])
          porcentajeCp = Number(
            this.tablaCalificaciones?.headers[rowIndex].valor
              ?.split("(")
              ?.pop()
              ?.split("%")[0]
          );
          row.valor = (Math.round(promedioCp * 10) / 10)
            .toFixed(1)
            .toString()
            .replace(".", ",");
          row.valor = this.fnNotasIncompletasArrRowValor(
            row,
            notasIncompletasCp
          );
        }

        if (this.tablaCalificaciones?.headers[rowIndex].valor.includes("PCE")) {
          porcentajeCe = Number(
            this.tablaCalificaciones?.headers[rowIndex].valor
              ?.split("(")
              ?.pop()
              ?.split("%")[0]
          );
          row.valor = this.fnRowValorPromedioCeEx(row, promedioCe, promedioEx);
          row.valor = this.fnNotasIncompletasArrRowValor(
            row,
            notasIncompletasCe
          );
        }

        if (this.tablaCalificaciones?.headers[rowIndex].valor === "CF") {
          let promedioCeEx = 0.0;
          promedioCeEx = promedioCe > promedioEx ? promedioCe : promedioEx;
          const promedioCf =
            +parseFloat(promedioCp.toString()).toFixed(2) *
              (parseFloat(porcentajeCp.toString()) / 100) +
            +parseFloat(promedioCeEx.toString()).toFixed(2) *
              (parseFloat(porcentajeCe.toString()) / 100);
          row.valor = parseFloat(promedioCf.toString())
            .toFixed(1)
            .replace(".", ",");
          row.valor = this.fnNotasIncompletasArrRowValor(
            row,
            notasIncompletasCp
          );
          row.valor = this.fnNotasIncompletasArrRowValor(
            row,
            notasIncompletasCe
          );

          if (this.tipoPortafolioTabla && this.estadoTabla !== "C") {
            row.valor = "-";
          }
        }
      });
    });
  }

  saveAsXlsxFile(base64: string, nombreArchivo: string) {
    const mediaType =
      "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
    const file = base64;
    let a = document.createElement("a");
    a.href = mediaType + file;
    a.download = nombreArchivo + ".xlsx";
    a.click();
  }

  descargarRegistroCalificaciones() {
    this._registroCalificaciones
      .descargarRegistroCalificaciones(this.configuracion)
      .subscribe((res: IResDescargaArchivo) => {
        if (res.error === null && res.archivo && res.nombreArchivo) {
          this.saveAsXlsxFile(res.archivo, res.nombreArchivo);
        } else {
          this.mostrarInfoModal(
            "Atención",
            res.error?.mensaje
              ? res.error.mensaje
              : "Hubo un error en los servicios"
          );
        }
      });
  }

  descargarActa(seccionId: number, anyo: number, periodo: number): void {
    if (!this.registrosEditables) {
      this._portalService.descargarActa(seccionId, anyo, periodo).subscribe({
        next: (res: IActa) => {
          if (res.error != null) {
            this.mostrarInfoModal(
              "Atención",
              res.error?.mensaje
                ? res.error.mensaje
                : "Hubo un error en los servicios"
            );
          } else {
            this.saveAsPdfFile(res.archivo, res.nombreArchivo);
          }
        },
        error: (error) => {
          setTimeout(() => {
            this.error = "";
          }, 3000);
        },
      });
    }
  }
  saveAsPdfFile(base64: string | null, nombreArchivo: string | null) {
    const mediaType = "data:application/pdf;base64,";
    const file = base64;
    let a = document.createElement("a");
    a.href = mediaType + file;
    a.download = nombreArchivo + ".pdf";
    a.click();
  }

  habilitarCpCeExSocket(alumnoFiltrado: any, habilitar: boolean = true) {
    alumnoFiltrado.row.forEach((filaAlumnoFiltrado: ITablaBodyRow) => {
      if (filaAlumnoFiltrado.tipoNota) {
        alumnoFiltrado.editable = habilitar;
        filaAlumnoFiltrado.editable = habilitar;
        if (!habilitar && filaAlumnoFiltrado.tipoNota !== "AN") {
          filaAlumnoFiltrado.valor = "0,0";
          filaAlumnoFiltrado.nuevoValor = "0,0";
        } else if (filaAlumnoFiltrado.tipoNota === "AN") {
          filaAlumnoFiltrado.valor = "";
          filaAlumnoFiltrado.nuevoValor = "";
        }
        this.registrosModificados = false;
      }
    });
  }

  guardarCalificaciones(
    redirect: boolean = false,
    autoguardado: boolean = false
  ) {
    if (this.arrNotasPorEnviar.length > 0) {
      this.reenviarNotasPendientes();
    } else {
      this.mostrarAlertaExito("Los cambios se han guardado correctamente.");
    }
    this.obtenerFechasEvaluaciones()
  }

  validarNotasCompletas() {
    let notasCompletas = true;
    this.tablaCalificaciones?.body.forEach((body: ITablaBody) => {
      if (
        body.visible &&
        body.editable &&
        body.situacionFinal != "RI" &&
        body.situacionFinal != "PP"
      ) {
        body.row.forEach((row: ITablaBodyRow) => {
          if (row.valor === "0,0" && row.tipoNota !== "EX" && row.editable) {
            notasCompletas = false;
          }
        });
      }
    });
    return notasCompletas;
  }

  cerrarSeccion() {
    if (this.validarNotasCompletas()) {
      document.getElementById("modal-confirmar-cierre-seccion")?.click();
    } else {
      document.getElementById("modal-estudiantes-sin-calificaciones")?.click();
    }
  }

  confirmarCierreSeccion() {
    document.getElementById("btn-cerrar-modal-cierre-seccion")?.click();
    this._registroCalificaciones
      .postCierreSeccion(this.configuracion)
      .subscribe((res: IResRegistroCalificaciones) => {
        if (res.error === null) {
          this.registrosEditables = false;
          clearTimeout(this.timeoutAutoguardado);
          this.mostrarAlertaExito("Se ha cerrado la sección con éxito.");
          this.obtenerCalificaciones(true);
        } else {
          this.mostrarInfoModal(
            "Atención",
            res.error?.mensaje
              ? res.error.mensaje
              : "No se pudo cerrar la sección"
          );
        }
      });
  }

  toggleDescripcionBb(index: number): void {
    const todosElementos = document.querySelectorAll(
      '[id^="check-integracion-container-"]'
    );
    const elemento = document.getElementById(
      `check-integracion-container-${index}`
    );

    if (elemento) {
      const isVisible = !elemento.classList.contains("d-none");
      todosElementos.forEach((elem) => this.renderer.addClass(elem, "d-none"));
      if (!isVisible) {
        this.renderer.removeClass(elemento, "d-none");
      }
    }
  }

  mostrarModalIntegracionBb() {
    if (!this.alineacionBbRealizada) {
      this.btnObtenerCalificacionesDeshabilitado = true;
    } else {
      this._integracionBb
        .obtenerCalificacionesAlineacion(
          this.configuracion.anyo,
          this.configuracion.periodoId,
          this.configuracion.asignaturaId,
          this.configuracion.sedeId,
          this.configuracion.seccionId
        )
        .subscribe((res: ICalificacionesAlineacion) => {
          this.ponderacionesAlineacionBb = res;
          if (this.ponderacionesAlineacionBb.error) {
            this.mensajeError = this.ponderacionesAlineacionBb.error.mensaje;
            document.getElementById("btn-modal-calificaciones-error")?.click();
          } else {
            if (
              this.ponderacionesAlineacionBb.columnas.length > 0
            ) {
              let listaPonderacionesNoEncontradas: any[] = [];
              this.ponderacionesAlineacionBb.columnas.forEach(
                (columna: any) => {
                  if (!columna.encontradaBb) {
                    this.deshabilitarSelectAll = true;
                    listaPonderacionesNoEncontradas.push(columna);
                  }
                }
              );
              this.cambiarEstadoPonderacionHeader(
                listaPonderacionesNoEncontradas
              );
              this.sortCalificaciones(this.ponderacionesAlineacionBb);
              const selectAll = document.getElementById(
                "seleccionarTodos"
              ) as HTMLInputElement;
              if (selectAll) selectAll.checked = false;
              document.getElementById("btn-modal-integracion-bb")?.click();
            }
          }
        });
    }
  }
  cambiarEstadoPonderacionHeader(ponderaciones: any[]) {
    ponderaciones.forEach((columna) => {
      const calificacion = this.tablaCalificaciones?.headers.find(
        (h) => h.valor.split(" ")[0] === columna.tipoNota + columna.nroNota
      );
      if (calificacion?.columanBb) {
        calificacion.columanBb.encontradaBb = columna.encontradaBb;
      }
    });
  }
  sortCalificaciones(ponderaciones: ICalificacionesAlineacion) {
    let columnas = ponderaciones.columnas;
    columnas.sort((a, b) => {
      if (a.tipoNota === "CP" && b.tipoNota === "CE") return -1;
      if (a.tipoNota === "CE" && b.tipoNota === "CP") return 1;

      return a.nroNota - b.nroNota;
    });
  }

  toggleAlineacion(bbColumnaId: any, event: any): void {
    if (event.srcElement.checked) {
      this.arrPonderacionesSincronizacionBb = [
        ...this.arrPonderacionesSincronizacionBb,
        bbColumnaId,
      ];
    } else {
      this.arrPonderacionesSincronizacionBb =
        this.arrPonderacionesSincronizacionBb.filter(
          (item) => item !== bbColumnaId
        );
    }
  }

  confirmarAlineacion(): void {
    this._integracionBb
      .sincronizarBlackboard({
        anyo: this.configuracion.anyo,
        periodoId: this.configuracion.periodoId,
        asignaturaId: this.configuracion.asignaturaId,
        sedeId: this.configuracion.sedeId,
        seccionId: this.configuracion.seccionId,
        columnaBBIds: this.arrPonderacionesSincronizacionBb,
      })
      .subscribe({
        next: (res: IResSincronizarBlackboard) => {
          document.getElementById("modal-integracion-bb-close")?.click();
          if (res.columnasSincronizadas) {
            if (res.columnasSincronizadas.length > 0) {
              // Cerrar modal actual y mostrar modal confirmacion
              if (
                res.error?.mensaje !== "No se encontraron notas para sincronizar"
              ) {
                setTimeout(() => {
                  document
                    .getElementById("btn-modal-calificaciones-cargadas")
                    ?.click();
                }, 50);
              }
              this.idCursoBlackboard = res.cursoBBId;
              res.columnasSincronizadas.forEach((columna) => {
                const index = this.tablaCalificaciones?.headers.findIndex(
                  (h) =>
                    h.valor.split(" ")[0] === columna.tipoNota + columna.nroNota
                );
                if (index && this.tablaCalificaciones) {
                  this.tablaCalificaciones.headers[index].columanBb = columna;
                }
              });
            }
          }
          //agregar distintos casos de error
          if (res.error !== null) {
            this.mensajeError = res.error.mensaje;
            setTimeout(() => {
              document
              .getElementById("btn-modal-calificaciones-error")
              ?.click();
            }, 50);
          }
          this.mostrarBtnObtenerCalificaciones = false;
          this.arrPonderacionesSincronizacionBb = [];
        },
        error: () => {
          document.getElementById("modal-integracion-bb-close")?.click();
        },
      });
  }
  seleccionarTodos(event: any) {
    const checkboxes = document.querySelectorAll(".form-check-input");
    checkboxes.forEach((checkbox: any) => {
      if (checkbox.checked !== event.target.checked) {
        document.getElementById(checkbox.id)?.click();
      }
    });
  }
  mostrarObtenerCalificaciones() {
    if (
      this.estadoSeccion === "CERRADA" ||
      this.estadoSeccion === "EN PROCESO" ||
      this.datosAlineacion.estadoAlineacion === "Validar" ||
      this.datosAlineacion.estadoAlineacion === "Configurar"
    ) {
      return false;
    } else {
      return true;
    }
  }
  navegarAlineacion() {
    this.router.navigate(["/alineacion-blackboard"], {
      state: {
        data: {
          estado: this.datosAlineacion.estadoAlineacion,
          idAlineacion: this.datosAlineacion.idAlineacion,
          datosSeccion: this.datosAlineacion.datosSeccion,
          filtros: this.configuracionFiltros,
          editable: this.registrosEditables,
        },
      },
    });
  }

  togglePopoverDetalleBb(divId: string, show: boolean = true) {
    const elemento: any = document.getElementById(divId)
    if (elemento && show) {
      this.renderer.removeClass(elemento, "d-none");
    } else {
      this.renderer.addClass(elemento, "d-none");
    }
  }
}
